export const initSteps = () => {
	function stepshow(step) {
		let step1 = document.getElementById('step1')
		let step2 = document.getElementById('step2')
		let step3 = document.getElementById('step3')
		let step4 = document.getElementById('step4')

		let step1Handle = document.getElementById('step1-handle')
		let step2Handle = document.getElementById('step2-handle')
		let step3Handle = document.getElementById('step3-handle')
		let step4Handle = document.getElementById('step4-handle')

		step1.classList.remove('step-description-show')
		step2.classList.remove('step-description-show')
		step3.classList.remove('step-description-show')
		step4.classList.remove('step-description-show')

		step1Handle.classList.remove('active')
		step2Handle.classList.remove('active')
		step3Handle.classList.remove('active')
		step4Handle.classList.remove('active')

		if (step == '1') {
			step1.classList.add('step-description-show')
			step1Handle.classList.add('active')
		}
		if (step == '2') {
			step2.classList.add('step-description-show')
			step2Handle.classList.add('active')
		}
		if (step == '3') {
			step3.classList.add('step-description-show')
			step3Handle.classList.add('active')
		}
		if (step == '4') {
			step4.classList.add('step-description-show')
			step4Handle.classList.add('active')
		}
	}


	let steps = document.querySelectorAll('.service-step .step-wrapper .step');

	steps.forEach((element) => {
		console.log(element);
		element.addEventListener("mouseover", function(e) {
			steps.forEach((element) => {
				element.classList.remove("active");
			});

			element.classList.add("active");
		});
	})

	window.stepshow = stepshow;
}
